<template>
  <div
    class="booking-block"
    :class="{
      'booking-block--check': valid,
      'booking-block--collapsed': collapsed,
    }"
  >
    <div class="booking-block__header" @click="collapsed = !collapsed">
      <div class="booking-block__header__icon booking-block__header__icon">
        <svg
          v-show="!valid"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 262.39 262.39"
          class="booking-icon booking-icon--miss"
        >
          <path
            d="M179.24,144.24l-12.72-12.73,12.72-12.73,70.19-70.2A25.16,25.16,0,1,0,213.85,13L131.5,95.34,48.81,12.65A25.16,25.16,0,1,0,13.22,48.23l69.92,69.92,12.73,12.73L83.15,143.61,13,213.81a25.16,25.16,0,1,0,35.58,35.58l82.35-82.34,82.69,82.69a25.16,25.16,0,1,0,35.58-35.58Z"
          />
        </svg>
        <svg
          v-show="valid"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 262.39 260.6"
          class="booking-icon booking-icon--check"
        >
          <path
            d="M248.88,3.42c-13-7-29.61-2.92-37.16,9.08v0L105.62,181.3,49.94,108.64C41.73,97,24.88,93.75,12.31,101.35s-16.09,23.2-7.87,34.83c.38.54.78,1.06,1.2,1.57L91.87,250.39a27.19,27.19,0,0,0,17.47,10.21h.15A26.82,26.82,0,0,0,126,248.92L258.71,37.83C266.24,25.81,261.84,10.42,248.88,3.42Z"
          />
        </svg>
      </div>
      <div class="booking-block__header__text">
        <h2 v-text="title"></h2>
        <p v-if="subTitle" v-text="subTitle"></p>
        <slot v-if="$slots.header" name="header"></slot>
      </div>
      <div class="booking-block__header__arrow">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 257.83 145.32">
          <path
            d="M241.44,0a16.26,16.26,0,0,0-11.59,4.81L137.22,97.43l-8.29,8.3-8.3-8.3L28,4.81A16.39,16.39,0,0,0,0,16.4,16.3,16.3,0,0,0,4.81,28L117.33,140.52a16.39,16.39,0,0,0,23.18,0L253,28A16.41,16.41,0,0,0,241.44,0Z"
          />
        </svg>
      </div>
    </div>
    <transition name="transition">
      <div class="booking-block__content" v-if="editMode" v-show="!collapsed">
        <slot name="edit"></slot>
        <button
          v-if="showSaveBtn"
          class="btn btn--positive booking-block__save-btn"
          v-text="translations.btn_save_and_close"
          @click="onSave"
        ></button>
      </div>
    </transition>
    <transition name="transition">
      <div
        class="booking-block__read-only"
        v-if="!editMode"
        v-show="!collapsed"
      >
        <slot name="view"></slot>
        <button
          v-if="showEditBtn"
          class="btn booking-block__edit-btn"
          v-text="translations.btn_edit"
          @click="onEdit"
        ></button>
      </div>
    </transition>
    <transition name="transition">
      <div
        class="booking-block__footer"
        v-if="$slots.footer"
        v-show="!collapsed"
      >
        <slot name="footer"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import { scrollTo } from "scroll-js";
import { trackEvent } from "../../tracker";

export default {
  props: {
    title: { type: String, default: "" },
    trackingTitle: { type: String, default: "" },
    subTitle: { type: String, default: "" },
    editMode: { type: Boolean, default: false },
    valid: { type: Boolean, default: false },
    isCollapsed: { type: Boolean, default: true },
    showSaveBtn: { type: Boolean, default: true },
    showEditBtn: { type: Boolean, default: true },
    scrollToElm: { type: Boolean, default: true },
  },
  watch: {
    isCollapsed() {
      if (this.isCollapsed != this.collapsed) {
        this.collapsed = this.isCollapsed;
      }
    },
    collapsed() {
      if (!this.collapsed && this.startTracking) {
        trackEvent({
          event: "Checkout - Dropdown udfold",
          action: this.trackingTitle || this.title,
          "interaction-type": "noninteraction",
        });
      }
    },
  },
  data() {
    return {
      collapsed: true,
      startTracking: false,
      translations: APP_CONFIG.TRANSLATION.BOOKING_BLOCK,
    };
  },
  created() {
    this.collapsed = this.isCollapsed;
  },
  mounted() {
    this.$nextTick(() => {
      this.startTracking = true;
    })
  },
  methods: {
    close() {
      this.collapsed = true;
      trackEvent({
        event: "Checkout - Gem og Luk",
        action: "Gem og luk",
        destination: this.trackingTitle || this.title,
        "interaction-type": "noninteraction",
      });
    },
    onSave() {
      this.$emit("save");
      this.scrollElementIntoView();
    },
    onEdit() {
      this.$emit("edit");
      this.scrollElementIntoView();
    },
    scrollElementIntoView() {
      if (this.scrollToElm && window.innerWidth < 900) {
        this.$nextTick(() => {
          let offset = document.getElementById("app").offsetTop;
          let elementScrollYPos = this.$el.offsetTop + offset;
          scrollTo(document.body, {
            top: elementScrollYPos,
            left: 0,
          });
        });
      }
    },
  },
};
</script>